import axios from 'axios'
// eslint-disable-next-line
import Qs from 'qs';
import { Message, Modal } from 'iview'

axios.defaults.timeout = 30000
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

// code状态码200判断
axios.interceptors.response.use((res) => {
  if (res.status !== 200) {
    Message.error('请求失败')
    return Promise.reject(res)
  }
  if (res.headers['content-disposition']) {
    return res
  }
  return res.data
}, (error) => {
  return Promise.reject(error)
})
export default {
  post (url, data) {
    return axios({
      method: 'post',
      url,
      data,
      timeout: 300000
    })
  },
  download (url, data) {
    return axios({
      url: url,
      method: 'post',
      data,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8' // 后端ssm框架接收json类型
      }
    })
  },

  upload (url, data) {
    return axios({
      url: url,
      method: 'post',
      data,
      responseType: 'Json' | 'blob',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8' // 后端ssm框架接收json类型
      }
    })
  },

  get (url, params) {
    return axios({
      method: 'get',
      url,
      params, // get 请求时带的参数
      timeout: 300000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      paramsSerializer: params => {
        return Qs.stringify(params, { indices: false })
      }
    })
  },

  delete (url, params) {
    return axios({
      method: 'delete',
      url,
      params, // delete 请求时带的参数
      timeout: 300000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
  },

  put (url, params) {
    // console.log(params)
    return axios({
      method: 'put',
      url,
      data: params, // put 请求时带的参数
      timeout: 300000
      // headers: {
      //   'X-Requested-With': 'XMLHttpRequest'
      // }
    })
  }
}
